import React from 'react'
import { Chiclet } from 'sutra/components/Chiclet/Chiclet'

import { SourceIcon } from 'components'
import {
  BarcodeIcon,
  NameCell,
  NameText,
  SourceIconWrapper,
  Thumbnail,
  TreeConnector,
} from 'features/catalog/features/table/components/CatalogTableNameCell/catalog-table-name-cell.styles'
import type { FocusListOption } from 'features/catalog/types'

type Props = {
  row: FocusListOption
  selectedLens: string
}

/** The table's Name column cell: a source icon / product thumbnail / bare
 * barcode placeholder, the row's title, and a Syndicated badge when
 * applicable. Extracted as its own sibling so `CatalogTable.tsx` stays under
 * the component-file-too-large threshold. */
export const CatalogTableNameCell: React.FC<Props> = ({
  row,
  selectedLens,
}) => (
  <NameCell>
    {selectedLens === 'source_type' ? (
      <SourceIconWrapper>
        <SourceIcon source={row.image_url ?? 'syndicated'} />
      </SourceIconWrapper>
    ) : row.image_url ? (
      <Thumbnail src={row.image_url} alt="" />
    ) : selectedLens === 'product_hierarchy' ? (
      <BarcodeIcon />
    ) : null}
    {row.displayLabel !== undefined && (
      <TreeConnector aria-hidden="true">└</TreeConnector>
    )}
    <NameText>{row.displayLabel ?? row.sourceName ?? row.value}</NameText>
    {row.syndicated && <Chiclet $size="sm">Syndicated</Chiclet>}
  </NameCell>
)
